import {
    APP_BOOTSTRAP_LISTENER,
    InjectionToken,
    Inject,
    Type,
} from '@angular/core';
import { EffectSources } from '@ngrx/effects';

export const BOOTSTRAP_EFFECTS: InjectionToken<string> = new InjectionToken(
    'Bootstrap Effects',
);

export function bootstrapEffects(
    effects: Type<any>[],
    sources: EffectSources,
): () => void {
    return () => {
        effects.forEach((effect: any) => sources.addEffects(effect));
    };
}

export function createInstances(...instances: any[]): any[] {
    return instances;
}

// eslint-disable-next-line
export function provideBootstrapEffects(effects: Type<any>[]) {
    return [
        effects,
        {
            provide: BOOTSTRAP_EFFECTS,
            deps: effects,
            useFactory: createInstances,
        },
        {
            provide: APP_BOOTSTRAP_LISTENER,
            multi: true,
            useFactory: bootstrapEffects,
            deps: [[new Inject(BOOTSTRAP_EFFECTS)], EffectSources],
        },
    ];
}
